import userRoutes from "../pages/user/routes";
import adminRoutes from "../pages/admin/routes";
import commonRoutes from "../pages/common/routes";

const routes = [...userRoutes, ...adminRoutes, ...commonRoutes];
export default routes;
